<div class="copilot-chart" *ngIf="chart" role="img" [attr.aria-label]="chart.title + (chart.description ? '. ' + chart.description : '')">
  <div class="copilot-chart__header">
    <div class="copilot-chart__title">{{ chart.title }}</div>
    <div class="copilot-chart__subtitle" *ngIf="chart.subtitle">{{ chart.subtitle }}</div>
    <div class="copilot-chart__meta" *ngIf="chart.unit || chart.description">
      <span *ngIf="chart.unit">{{ chart.unit }}</span>
      <span *ngIf="chart.unit && chart.description"> · </span>
      <span *ngIf="chart.description">{{ chart.description }}</span>
    </div>
  </div>

  <svg
    class="copilot-chart__svg"
    [attr.viewBox]="'0 0 ' + width + ' ' + height"
    [attr.width]="width"
    [attr.height]="height"
    focusable="false"
    aria-hidden="true"
  >
    <ng-container *ngIf="isCartesian">
      <line
        *ngFor="let tick of yTicks"
        [attr.x1]="pad.left"
        [attr.x2]="width - pad.right"
        [attr.y1]="tick.y"
        [attr.y2]="tick.y"
        class="copilot-chart__grid"
      ></line>
      <text
        *ngFor="let tick of yTicks"
        [attr.x]="pad.left - 6"
        [attr.y]="tick.y + 3"
        class="copilot-chart__tick"
        text-anchor="end"
      >{{ tick.label }}</text>

      <line
        [attr.x1]="pad.left"
        [attr.x2]="width - pad.right"
        [attr.y1]="baselineY"
        [attr.y2]="baselineY"
        class="copilot-chart__baseline"
      ></line>

      <rect
        *ngFor="let bar of barRects"
        [attr.x]="bar.x"
        [attr.y]="bar.y"
        [attr.width]="bar.width"
        [attr.height]="bar.height"
        [attr.fill]="bar.color"
        rx="2"
      >
        <title>{{ barTooltip(bar) }}</title>
      </rect>

      <text
        *ngFor="let label of barValueLabels"
        [attr.x]="label.x"
        [attr.y]="label.y"
        class="copilot-chart__bar-value"
        text-anchor="middle"
      >{{ label.text }}</text>

      <rect
        *ngFor="let bar of stackedRects"
        [attr.x]="bar.x"
        [attr.y]="bar.y"
        [attr.width]="bar.width"
        [attr.height]="bar.height"
        [attr.fill]="bar.color"
      >
        <title>{{ barTooltip(bar) }}</title>
      </rect>

      <ng-container *ngFor="let line of linePaths">
        <path [attr.d]="line.d" fill="none" [attr.stroke]="line.color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
        <circle
          *ngFor="let p of line.points"
          [attr.cx]="p.x"
          [attr.cy]="p.y"
          r="3"
          [attr.fill]="line.color"
        ></circle>
      </ng-container>

      <ng-container *ngIf="referenceLineY as refY">
        <line
          [attr.x1]="pad.left"
          [attr.x2]="width - pad.right"
          [attr.y1]="refY"
          [attr.y2]="refY"
          class="copilot-chart__reference"
        ></line>
        <text
          [attr.x]="width - pad.right"
          [attr.y]="refY - 4"
          class="copilot-chart__reference-label"
          text-anchor="end"
        >{{ chart.referenceLine?.label }}</text>
      </ng-container>

      <text
        *ngFor="let lab of categoryLabels"
        [attr.x]="lab.x"
        [attr.y]="lab.y"
        class="copilot-chart__cat"
        [attr.text-anchor]="lab.rotate ? 'end' : 'middle'"
        [attr.transform]="lab.rotate ? 'rotate(-40 ' + lab.x + ' ' + lab.y + ')' : null"
      >
        <title>{{ lab.full }}</title>
        {{ lab.text }}
      </text>
    </ng-container>

    <ng-container *ngIf="isPie">
      <path *ngFor="let slice of pieSlices" [attr.d]="slice.path" [attr.fill]="slice.color">
        <title>{{ slice.label }}: {{ formatValue(slice.value) }} ({{ slice.percent | number:'1.0-0' }}%)</title>
      </path>
    </ng-container>
  </svg>

  <ul class="copilot-chart__legend" *ngIf="legendItems.length" [class.copilot-chart__legend--ranked]="categoryLabelMode === 'legend'">
    <li
      *ngFor="let item of legendItems"
      [matTooltip]="tooltipFor(item)"
      matTooltipShowDelay="150"
      matTooltipClass="copilot-chart-tooltip"
    >
      <span class="copilot-chart__swatch" [style.background]="item.color" aria-hidden="true"></span>
      <span class="copilot-chart__legend-label">{{ item.label }}</span>
      <span class="copilot-chart__legend-value" *ngIf="item.value != null">{{ item.value }}</span>
    </li>
  </ul>
</div>
